module.exports = __webpack_public_path__ + "img/en-flag.32baf2fb.svg";